export default __webpack_public_path__ + "static/media/slide-one.81665e46.png";